import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { withStyles } from '@material-ui/core/styles';

import messages from './messagesExchangeOrder';
import styles from './styles';

function ExchangeOrderNotification({
    classes,
    cancelledTFPassengers,
    isConfirmation,
}) {
    return (
        <div className={classes.warning}>
            <FormattedMessage {...messages.lblCancelledTFFirst} />
            <List component="ul" className={classes.warningList}>
                {cancelledTFPassengers && cancelledTFPassengers.map((item, index) => (
                    <ListItem className={classes.warningListItem} key={index}>
                        <ListItemText
                            disableTypography
                            primary={(
                                <FormattedMessage
                                    {...messages.lblCancelledTFFor}
                                    values={{ fare: item.get('fareDisplayName'), name: item.get('passengerNames').toJS().join(', ') }}
                                />
                            )}
                        />
                    </ListItem>
                ))}
            </List>
            {!isConfirmation && (<FormattedMessage {...messages.lblCancelledTFLast} />)}
        </div>
    );
}

ExchangeOrderNotification.propTypes = {
    classes: PropTypes.object.isRequired,
    cancelledTFPassengers: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object,
    ]).isRequired,
    isConfirmation: PropTypes.bool,
};

export { ExchangeOrderNotification as ExchangeOrderNotificationAlias };

export default withStyles(styles)(ExchangeOrderNotification);
